// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.prof-school-form__years-selects-cont .sk-select__list {\n  top: auto;\n  bottom: calc(100% + 2px);\n  max-height: 200px;\n}\n", ""]);
// Exports
module.exports = exports;
